module.exports = __webpack_public_path__ + "img/es.f9251ee5.svg";